import React, { useState, useContext } from "react";
import { Col, Form } from "react-bootstrap";
import { SettingsContext } from './AccountSettingsButton'
import jsDig from "utils/jsDig.js";
import { v4 as uuidv4 } from "uuid";

export default function ScriptBoxes(props) {

  const context = useContext(SettingsContext);

  const handleCheckbox = (e, name) => {
    context.setGoogleAdsScripts({
      ...context.googleAdsScripts,
      [name]: e.target.checked ? "1" : "0"
    });
  }

  const handleScriptVariableChange = (e, scriptName, optionName) => {
    context.setScriptVariables({
      ...context.scriptVariables,
      [scriptName]: {
        ...context.scriptVariables[scriptName],
        [optionName]: e.target.value
      }
    });
  }

  // Exclude NB in Shopping Script Vars

  const brandedKeywords = jsDig(["exclude_nb_in_shopping", "branded_keywords"], context.scriptVariables)

  const deleteBrandedKeyword = (e, kwNum) => {
    e.preventDefault();
    let newBrandedKeywords = {...brandedKeywords};
    delete newBrandedKeywords[kwNum];
    context.setScriptVariables({
      ...context.scriptVariables,
      exclude_nb_in_shopping: {
        ...context.scriptVariables.exclude_nb_in_shopping,
        branded_keywords: newBrandedKeywords
      }
    });
  };

  const addBrandedKeyword = (e) => {
    e.preventDefault();
    const newKey = uuidv4()
    context.setScriptVariables({
      ...context.scriptVariables,
      exclude_nb_in_shopping: {
        ...context.scriptVariables.exclude_nb_in_shopping,
        branded_keywords: {
          ...brandedKeywords,
          [newKey]: ""
        }
      }
    });
  };

  const handleBrandedKeywordChange = (kwNum, value) => {
    let oldKeywords = jsDig(["exclude_nb_in_shopping", "branded_keywords"], context.scriptVariables);
    let newKeywords = {...oldKeywords, [kwNum]: value};
    handleScriptVariableChange({target: {value: newKeywords}}, "exclude_nb_in_shopping", "branded_keywords");
  };

  return (
    <>
      {props.scripts.map((script) => {
        const scriptBoxClass = (script.name == "exclude_nb_in_shopping" || script.name == "youtube_channel_excluder") ? "script-box-wide" : "script-box";
        return (
          <React.Fragment key={script.name}>
            <Col key={script.name} className={scriptBoxClass}>
              <div className="h-100 script-box-bg">
                <div className="mb-2">
                  <div className="lite-checkbox-container">
                    <input
                      type="checkbox"
                      className="lite-checkbox "
                      id={`google_ads_scripts_${script.name}`}
                      name={`google_ads_scripts[${script.name}]`}
                      onChange={(e) => {handleCheckbox(e, script.name)}}
                      defaultChecked={
                        context.googleAdsScripts[script.name] == "1" ? true : false     
                      }
                    />
                    <label className="custom-label script-title" htmlFor={`google_ads_scripts_${script.name}`}>{script.title}</label>
                  </div>
                </div>
                <div>
                  <p className="f12">{script.desc}</p>
                </div>
              
                {script.name == "pmax_performance_reporting_script" && (
                  <>
                    <div>
                      <p className="f12 pb-1">Please create a copy of <a href="https://docs.google.com/spreadsheets/d/17KX2o2EExc2JgKD7tWXIoWn7BW7w2_dOgoQFhGyVr-c/edit?usp=sharing" target="_blank" style={{textDecoration: "underline"}}>this</a> google sheet before enabling this script.</p>
                      <p className="f12 pb-3"><i>Edit access must be granted to support@digitalposition.com</i></p>
                    </div>
                  </>
                )}

                {script.name == "exclude_nb_in_shopping" ? ( // EXCLUDE NON-BRAND IN SHOPPING SCRIPT
                  <>
                    <div>
                      <p className="f12 pb-1">Please add branded keywords - keywords should only match variations of the company name, no long-tail keywords:</p>
                      <p className="f12 pb-3"><i>All keywords with more than 0 clicks in the past 30 days will be analyzed</i></p>
                    </div>
                    <div className="d-flex" style={{gap: "12px"}}>
                      <div className="script-list d-flex flex-wrap" style={{columnGap: "12px"}}>
                        {brandedKeywords && Object.keys(brandedKeywords).map((kwNum, i) => {
                          return (
                            <div key={i} className="d-flex align-items-center pb-2" style={{gap: "8px"}}>
                              <span className="list-number d-none" style={{minWidth: "22px"}}>{kwNum}.</span>
                                <input
                                  name={`scripts[${script.name}][branded_keywords][${kwNum}]`}
                                  value={jsDig([kwNum], brandedKeywords) || ""}
                                  onChange={(e) => handleBrandedKeywordChange(kwNum, e.target.value)}
                                />
                              <span className="delete-icon" style={{cursor: "pointer"}} onClick={(e) => deleteBrandedKeyword(e, kwNum)}>
                                <i className="fas fa-trash-alt" style={{fontSize: "12px"}}></i>
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <button className="green-button" onClick={(e) => addBrandedKeyword(e)}>Add +</button>
                  </>
                ) : (script.name == "youtube_channel_excluder") ? ( // YOUTUBE CHANNEL EXCLUDER SCRIPT
                  <>
                    <div>
                      <p className="f12 pb-1">Please create a copy of <a href="https://docs.google.com/spreadsheets/d/1kzY39AwTnidat-xzFpcVcs7kPavNXNbjVrm-qPoJPCk" target="_blank" style={{textDecoration: "underline"}}>this</a> google sheet before enabling this script.</p>
                      <p className="f12 pb-3"><i>Edit access must be granted to support@digitalposition.com</i></p>
                    </div>
                    <div className="script-options d-flex flex-column" style={{gap: "8px"}}>
                      <div className="mb-0 form-group">
                        <label className="f12 font-weight-bold pb-2 form-label" htmlFor={`script_variables[${script.name}][google_sheet]`}>
                          Google Sheet
                        </label>
                        <input 
                          name={`script_variables[${script.name}][google_sheet]`} 
                          placeholder="https://docs.google.com/spreadsheets/..."
                          id={`script_variables[${script.name}][google_sheet]`} 
                          className="d-inline form-control form-control-sm" 
                          defaultValue={jsDig([script.name, "google_sheet"], context.scriptVariables)}
                          onChange={(e) => {
                            handleScriptVariableChange(e, script.name, "google_sheet");
                          }}
                        ></input>
                      </div>
                      <div className="mb-0 form-group">
                        <label className="f12 font-weight-bold pb-2 form-label" htmlFor={`script_variables[${script.name}][allowed_countries]`}>
                          Allowed Countries
                        </label>
                        <p className="f12 pb-2"><i>Please supply a regex formula to specfify which countries you would like to whitelist. (E.g. <b>^US|UK|CA$</b>) </i></p>
                        <input
                          name={`script_variables[${script.name}][allowed_countries]`}
                          placeholder="^US$"
                          id={`script_variables[${script.name}][allowed_countries]`}
                          className="d-inline form-control form-control-sm"
                          defaultValue={jsDig([script.name, "allowed_countries"], context.scriptVariables)}
                          onChange={(e) => {
                            handleScriptVariableChange(e, script.name, "allowed_countries");
                          }}
                        ></input>
                      </div>
                      <div className="mb-0 form-group">
                        <label className="f12 font-weight-bold pb-2 form-label" htmlFor={`script_variables[${script.name}][impressions_time_range]`}>
                          Impressions Time Range
                        </label>
                        <p className="f12   pb-2"><i>Select a predefined time range.</i></p>
                        <div className="select-wrapper">
                          <select
                            name={`script_variables[${script.name}][impressions_time_range]`}
                            id={`script_variables[${script.name}][impressions_time_range]`}
                            defaultValue={jsDig([script.name, "impressions_time_range"], context.scriptVariables)}
                            onChange={(e) => {
                              handleScriptVariableChange(e, script.name, "impressions_time_range");
                            }}
                          >
                            <option value="LAST_7_DAYS">LAST_7_DAYS</option>
                            <option value="LAST_14_DAYS">LAST_14_DAYS</option>
                            <option value="LAST_30_DAYS">LAST_30_DAYS</option>
                            <option value="LAST_90_DAYS">LAST_90_DAYS</option>
                          </select>
                        </div>
                      </div>
                      <div className="mb-0 form-group">
                        <label className="f12 font-weight-bold pb-2 form-label" htmlFor={`script_variables[${script.name}][impressions_threshold]`}>
                          Impressions Threshold
                        </label>
                        <p className="f12 pb-2"><i>Minimum number of impressions to consider a channel for exclusion.</i></p>
                        <input
                          name={`script_variables[${script.name}][impressions_threshold]`}
                          placeholder="Default: 1"
                          id={`script_variables[${script.name}][impressions_threshold]`}
                          className="d-inline form-control form-control-sm"
                          defaultValue={jsDig([script.name, "impressions_threshold"], context.scriptVariables)}
                          onChange={(e) => {
                            handleScriptVariableChange(e, script.name, "impressions_threshold");
                          }}
                        ></input>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {script.options && (
                      <div className="script-options pt-2">
                        <div className="script-options d-flex flex-column" style={{gap: "8px"}}>
                          {script.options.map((option) => {
                            return (
                              <div className="mb-0 form-group" key={`${script.name}-${option.name}`}>
                                <label className="f12 font-weight-bold pb-2 form-label" htmlFor={`script_variables[${script.name}][${option.name}]`}>
                                  {option.title}
                                </label>
                                {option.desc && (
                                  <p className="f12 mb-2"><i>{option.desc}</i></p>
                                )}
                                <input 
                                  name={`script_variables[${script.name}][${option.name}]`} 
                                  placeholder={option.placeholder} 
                                  id={`script_variables[${script.name}][${option.name}]`} 
                                  className="d-inline form-control form-control-sm" 
                                  defaultValue={jsDig([script.name, option.name], context.scriptVariables)}
                                  onChange={(e) => {
                                    handleScriptVariableChange(e, script.name, option.name);
                                  }}
                                ></input>
                              </div>
                            )
                          })}
                        </div>
                          
                      </div>
                    )}
                  </>
                )}
              </div>
            </Col>
          </React.Fragment>
        );
      })}
    </>
  )
}
